export enum EAuthenticationFlow {
  SSO = 'SSO',
  LOGIN_PASSWORD = 'LOGIN_PASSWORD',
  SET_PASSWORD = 'SET_PASSWORD',
}

export type TAuthenticationFlowsResponse = EAuthenticationFlow[];

export type TSignInAmplifyUI = {
  email: string;
  password: string;
};

export type TSignInChallengeUI = {
  challengeName: string;
};

export enum EResetPasswordCasesDb {
  RESENT_CODE = 'RESENT_CODE',
  RESENT_PASSWORD = 'RESENT_PASSWORD',
  RESEND_INVITATION = 'RESEND_INVITATION',
}

export enum EResetPasswordCasesUI {
  RESENT_CODE = 'RESEND_CODE',
  RESENT_PASSWORD = 'RESET_PASSWORD',
  RESEND_INVITATION = 'RESEND_INVITATION',
}

export type TResetPasswordCasesUI = { email: string };
export type TResetPasswordCasesDb = { username: string };

export type TResetPasswordDb = {
  passwordResendStatus: EResetPasswordCasesDb;
  admin: boolean;
};

export type TResetPasswordUI = {
  passwordResendStatus: EResetPasswordCasesUI;
  isAdmin: boolean;
};

export type TResetPasswordFormUI = {
  code: string;
  password: string;
  email: string;
};

export type TResetPasswordFormDb = {
  code: string;
  password: string;
  username: string;
};

export type TSetPasswordFormUI = {
  password: string;
  email: string;
  temporaryPassword: string;
};

export type TSetPasswordFormDb = {
  newPassword: string;
  username: string;
  temporaryPassword: string;
};
